import { createStore } from 'vuex'
import lookups from './lookups'
import contract from './contract'
import { Confirm } from '@/interfaces/confirm.interface'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement)
export interface User {
  email: string,
  name: string
}
export interface Toast {
  type?: string,
  message: string,
  title?: string,
  visible?: boolean
}
export interface State {
  isLogout: boolean,
  user: User | null,
  toast: Toast,
  confirm: Confirm,
  confirmResolve: any,
  confirmReject: any,
  darkMode: boolean
}
export default createStore<State>({
  state: {
    isLogout: false,
    user: null,
    toast: { message: '', type: 'success', visible: false },
    confirm: {
      message: '',
      type: 'warning',
      visible: false,
      currency: false,
      noClose: false,
      isCancelType: false,
      isCashe: false
    },
    confirmResolve: undefined,
    confirmReject: undefined,
    darkMode: false
  },
  mutations: {
    SHOW_CONFIRM (state, data = {}) : void {
      state.confirm = data
      state.confirm.visible = true
    },
    CONFIRM_YES (state) : void {
      if (!state.confirm.noClose) {
        state.confirm.visible = false
      }
    },
    CONFIRM_NO (state) : void {
      state.confirm.visible = false
    },
    IS_LOGOUT (state, data) : void {
      state.isLogout = data
    },
    SET_USER (state, data) : void {
      state.user = data
    },
    HIDE_TOAST (state) : void {
      state.toast.visible = false
    },
    SHOW_TOAST (state, data: Toast) : void {
      state.toast.title = data.title
      state.toast.message = data.message
      state.toast.type = data.type || ''
      const isVisible = state.toast.visible
      if (isVisible) {
        state.toast.visible = false
        setTimeout(() => {
          state.toast.visible = true
        }, 200)
      } else {
        state.toast.visible = true
      }
    },
    CHANGE_MODE () : void {
      const mode = localStorage.getItem('mode')
      localStorage.setItem('mode', mode !== 'light' ? 'light' : 'dark')
    },
    SET_THEME (state) : void {
      const mode = localStorage.getItem('mode')
      state.darkMode = mode !== 'light'
      setTimeout(() => {
        const html = document.getElementsByTagName('html')[0]
        html.setAttribute('data-theme', mode || 'dark')
        if (state.darkMode) {
          ChartJS.defaults.color = 'rgb(235, 236, 240)'
        } else {
          ChartJS.defaults.color = 'rgb(31, 41, 55)'
        }
      }, 200)
    }
  },
  actions: {
    show_toast (context, data: Toast) {
      context.commit('SHOW_TOAST', data)
    },
    hide_toast (context) {
      context.commit('HIDE_TOAST')
    },
    set_user (context, data) {
      context.commit('SET_USER', data)
    },
    is_logout (context, data) {
      context.commit('IS_LOGOUT', data)
    },
    show_confirm (context, data) {
      context.commit('SHOW_CONFIRM', data)
      return new Promise((resolve, reject) => {
        context.state.confirmResolve = resolve
        context.state.confirmReject = reject
      })
    },
    hide_confirm (context) {
      context.commit('CONFIRM_NO')
    },
    confirm_yes (context, data) {
      context.commit('CONFIRM_YES')
      context.state.confirmResolve(data)
    },
    confirm_no (context) {
      context.commit('CONFIRM_NO')
      context.state.confirmReject('cancel')
    },
    change_mode (context) {
      context.commit('CHANGE_MODE')
      context.dispatch('set_theme')
    },
    set_theme (context) {
      context.commit('SET_THEME')
    }
  },
  getters: {
    darkMode: (state) => state.darkMode,
    user: (state) => state.user,
    toast: (state) => state.toast,
    isLogout: (state) => state.isLogout,
    confirm: (state) => state.confirm,
    aimagCities: (state : any) => state.lookups.aimagCities,
    customerVisible: (state : any) => state.contract.customerVisible,
    customerRegisterNum: (state : any) => state.contract.customerRegisterNum,
    customerText: (state : any) => state.contract.customerText
  },
  modules: {
    lookups,
    contract
  }
})
